module.exports = __webpack_public_path__ + "static/img/fenzu2.c39a779.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/fenzu2.png
// module id = OchU
// module chunks = 24